import * as z from "zod/v4";

export const ShopperAgentCooldownConfigSchema = z.object({
  cooldownHours: z.number().optional(),
});

export type ShopperAgentCooldownConfig = z.infer<
  typeof ShopperAgentCooldownConfigSchema
>;
